var map = {
	"./home_gg_1.png": "cv+s",
	"./home_gg_2.png": "wJay",
	"./home_gg_2_backup.png": "ItgY"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "rLeh";


//////////////////
// WEBPACK FOOTER
// ./src/assets ^\.\/home_gg_.*\.png$
// module id = rLeh
// module chunks = 1